import { Controller, useFormContext } from "react-hook-form";
import type { SelectProps } from "@circle-react-uikit/Select";
import { Select } from "@circle-react-uikit/Select";

export interface FormSelectProps extends SelectProps {
  name: string;
}

export const FormSelect = ({ name, ...passThroughProps }: FormSelectProps) => {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={name}
      render={({
        field: { onChange, value, name },
      }: {
        field: {
          onChange: (value: string) => void;
          value: string;
          name: string;
        };
      }) => (
        <Select
          {...passThroughProps}
          name={name}
          onChange={({ value }) => onChange(value)}
          value={value}
        />
      )}
    />
  );
};

FormSelect.displayName = "Form.Select";
